<template>
  <v-btn
    color="primary"
    fab
    middle
    dark
    bottom
    left
    class="btn-adicionar-novo"
    @click="adicionarNovo"
  >
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'SGPBotaoAdicionarNovoComponent',

  methods: {
    adicionarNovo () {
      this.$emit('sgpAdiconarNovoEmit')
    }
  }
}
</script>